import * as React from "react"
import Header from '../components/header'
import Slider from "../components/slider"
import Seo from "../components/seo"

import { animate, motion, scroll } from "framer-motion"
import { useStaticQuery, graphql, Link,} from "gatsby"
import { IconMouse, IconArrowLeft } from "@tabler/icons-react"

import { StaticImage } from "gatsby-plugin-image"

export default function IndexPage(){
 

  return (
    <main className="flex flex-col relative overflow-hidden">
      
      <Header/>

        <motion.div 
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, type: 'spring' }}
            className="pt-[80px] flex flex-col h-[100vh] justify-center items-center"
        >
            {/* <StaticImage src={"../images/icon-rf-red-big.png"} className="max-w-[60px] lg:max-w-[80px] mb-4" placeholder="none"/> */}
            <h1 className="text-center text-9xl md:text-9xl lg:text-10xl -mb-8 text-red">404</h1>
            <h4 className="text-center text-3xl md:text-3xl lg:text-6xl mb-4">NOT FOUND</h4>
            <p className="max-w-[500px] text-center">Oops! The page you’re looking for doesn’t exist. Check the URL or return to our homepage.</p>
            <br />
            <Link to={'/'} className="flex gap-2 hover:gap-4 transition-gap duration-200 text-red items-center" ><IconArrowLeft size={20} color={'#A91E22'} style={{marginBottom: '2px'}}/>  <span>Return to home</span></Link>
        </motion.div>
    </main> 
  )
}


export function Head({data}){

  const {site:{siteMetadata}} = data

  return(
    <Seo
      title={siteMetadata.title}
      description={siteMetadata.description}
      url={siteMetadata.siteUrl + '/success'}
      image={'../images/opengraph-royal.webp'}

    >    
      <meta name={'robots'} content={'nofollow'} />
    </Seo>
  )

}



export const query = graphql`
query Contact {
    site{
        siteMetadata{
            siteUrl
            title
            description
        }
    }
}


`